import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-105" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-106" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Take a Look Inside" body="Professional, visual resources designed to make complex hair techniques easier to teach and easier to understand." data-id="element-107" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-108" data-mp="2352j65cxbyiz">
          <InsidePagesCarousel data-id="element-109" data-mp="1y7kguxtewhjy" />
        </div>

        <p className="mt-6 text-center font-body text-[13px] italic text-brand-charcoal/55" data-id="element-110" data-mp="1y8c15chk6sux">
          Real pages from inside Hair Instructor Ready™
        </p>
      </div>
    </section>;
}